export default __webpack_public_path__ + "2e88a035c6098714993b29da6a2d3c32.png";